"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Vector = require("esri-leaflet-vector");
const core_1 = require("@react-leaflet/core");
const EsriLeafletLayer_1 = require("../build/EsriLeafletLayer");
const createEsriLayer = (props, context) => {
    const instance = Vector.vectorBasemapLayer(props.name, { ...props });
    return { instance, context };
};
/**
 * VectorBasemapLayer component, react-leaflet wrapper for [L.esri.Vector.vectorBasemapLayer](https://developers.arcgis.com/esri-leaflet/api-reference/layers/vector-basemap/).
 *
 * For more info: https://github.com/slutske22/react-esri-leaflet#vectorbasemaplayer-and-vectortilelayer
 */
const VectorBasemapLayer = (0, core_1.createLayerComponent)(createEsriLayer, EsriLeafletLayer_1.updateEsriLayer);
exports.default = VectorBasemapLayer;
